import constants from "../constants";
import successHandle from "../../utils/successHandle";
import errorHandle from "../../utils/errorHandle";

const {
  GET_SELECTED_PRODUCTS, GET_SELECTED_PRODUCTS_SUCCESS, GET_SELECTED_PRODUCTS_ERROR,
  ADD_SELECTED_PRODUCT, ADD_SELECTED_PRODUCT_SUCCESS, ADD_SELECTED_PRODUCT_ERROR,
  EDIT_SELECTED_PRODUCT, EDIT_SELECTED_PRODUCT_SUCCESS, EDIT_SELECTED_PRODUCT_ERROR,
  DELETE_SELECTED_PRODUCT, DELETE_SELECTED_PRODUCT_SUCCESS, DELETE_SELECTED_PRODUCT_ERROR
} = constants;

const initialState = { loading: false, selectedProducts: [], message: '', error: '' }

export const selectedProductReducer = (state = initialState, action) => {
  const { type, products, message, error, selectedProducts } = action;
  switch (type) {
    case GET_SELECTED_PRODUCTS:
    case ADD_SELECTED_PRODUCT:
    case EDIT_SELECTED_PRODUCT:
    case DELETE_SELECTED_PRODUCT:
      return { ...state, loading: true, error: '', message: '' }

    case GET_SELECTED_PRODUCTS_SUCCESS:
      return { ...state, loading: false, selectedProducts }
    case ADD_SELECTED_PRODUCT_SUCCESS:
    case EDIT_SELECTED_PRODUCT_SUCCESS:
    case DELETE_SELECTED_PRODUCT_SUCCESS:
      return { ...state, loading: false, message: successHandle(message) }

    case GET_SELECTED_PRODUCTS_ERROR:
    case ADD_SELECTED_PRODUCT_ERROR:
    case EDIT_SELECTED_PRODUCT_ERROR:
    case DELETE_SELECTED_PRODUCT_ERROR:
      return { ...state, loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
